module.exports = __webpack_public_path__ + "static/img/successBg.03b764e2.png";